<template>

  <v-dialog
    v-model="show"
    persistent
    fullscreen
    >
    <div style="background: #f0f0f0; padding: 6px; min-height: 100%;">
    <v-toolbar class="ma-1"  dense  elevation="0" rounded>
            <v-icon left >mdi-playlist-plus</v-icon><span class="va-underline">Job Order</span>
            <v-spacer/>
            <v-btn  @click="emitToParent('close')" fab x-small elevation="1" color="warning"><v-icon >mdi-close</v-icon></v-btn>
          </v-toolbar>
    <v-row>
      

      <v-col cols="12" sm="6">
         <v-card class="ma-1">
        
              <v-card-text>
                <table class="va-table va-table-border-bot">
                  <tr>
                   
                    <th>Item</th>
                    <th>Description</th>
                 
                  </tr>
                  <tr  v-for="(item, index) in sales_items" :key="index+'-l'">
                    <td><span class="font-weight-bold">{{ item.name }}</span>
                        <br/><span class="font-italic def-font text-info" v-if="item.code!='null'">code: {{ item.code }}</span>
                    </td>
                     <td>
                    
                      <p class="ma-1">{{ item.description }}</p>
                        <p class="ma-1 def-font" v-for="(_prop, _index) in item.properties" :key="_index+'-p'">{{_prop.name}} : {{_prop.value}} </p>
                    </td>
                    
                   
                  </tr>
                  
                </table>         
              </v-card-text>
              
          </v-card>
          
        <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
          <v-card class="ma-1">
            <v-card-text>
              <div>
                <span class="font-weight-bold lg-font" style="float:right">{{sales.type}}</span>
                <span class="font-weight-bold lg-font">Number: {{sales.id}}</span>
                <a :href="'/view-job/' + sales.id" target="_blank" rel="noopener noreferrer"><v-icon right small color="info">mdi-open-in-new</v-icon></a>
                 <v-divider class="mb-4"/>
              </div>
            Customer Details
              <v-divider class="mb-4"/>
              <v-autocomplete
              v-model="sales.customer_id"
              :items="customers"
              filled
             
              color="blue-grey lighten-2"
              label="Select Customer"
              item-text="fullname"
              :rules="textRules"
              :disabled="action!='new'"
              item-value="id"
              hide-details
            >
            
              <template v-slot:item="data">
                  <div class="va-drop-list">
                     {{data.item.fullname}}
                      <br />
                     <span class="md-font font-italic text-info font-weight-thin"> Mobile: {{data.item.mobile}}</span>
                  </div>
              </template>
            </v-autocomplete>
            <a class="md-font font-italic text-info" v-if="action=='new'" @click="customer_state='new',cusform=true">
              <v-icon left small color="info">mdi-plus</v-icon>New Customer</a>
            <p class="mt-2" v-if="action!='new'"> Mobile: {{sales.customer_data.mobile}}</p>
      
              <v-divider class="mt-4 mb-4" />
              <v-row v-if="action=='modify'">
                  
                  <v-col cols="6">Remarks: <br /><span class="font-weight-bold lg-font">{{sales.remarks}}</span> </v-col>
                  <v-col cols="6">Status: <br /><span class="font-weight-bold lg-font">{{sales.status}}</span> </v-col>
                 
              </v-row>
              
              <v-divider class="mt-4 mb-4" />
              <div>
              <v-btn class="ma-2"
               v-if="sales.type=='Job Order' && sales.status=='Pending' && ALLOWEDACTION('accept_job')"
                color="primary"
                 @click="sales.status='In Progress', sales.remarks='Assigned to our team', AcceptJob('Job Order is now assigned to our team')" 
                >
               Job Order Accept
              </v-btn>
               <v-btn class="ma-2"
               v-if="sales.type=='Job Order' && sales.status=='In Progress' && ALLOWEDACTION('accept_job')"
                color="primary"
                 @click="sales.status='For Inspection', sales.remarks='Waiting for quality inspection', AcceptJob('For quality inspection')" 
                >
               For Inspection
              </v-btn>
              
               
                <!-- <v-btn  class="ma-2">For Inspection</v-btn>
               
                <v-btn  class="ma-2">Completed</v-btn> -->
             </div>   
             </v-card-text> 
             
          </v-card>
          </v-form>
         
      </v-col>
       <v-col cols="12" sm="6">
               <div class="pa-2">
            <p class="pa-1 ma-0">Media Files</p>
            <v-divider class="mb-2"/>
            <span v-if="sales.files !='' ">
                   <img 
                   width="150"
                   class="imgview"
                   @click="imgsrc = img, imgview=true"
                  v-for="(img,m) in sales.files"
                  :key="m +'-fm'"
                   :src="img">
            </span>
          </div>
           
           
          <div class="ma-1" v-if="action=='modify' && sales.status=='In Progress'">
          
              <zera-s3-upload :show="s3upload" @zeraEvent="s3Ev"/>
          </div>
          <div class="ma-1 mt-4" v-if="action=='modify'">
              <widgets-service-logs :sales="sales" :show="activity"/>
          </div>
          
        </v-col>
     
    </v-row>      

  
  </div>
    <va-confirm :show="confirm.show" :message="confirm.message"  :cancelbtn="confirm.cancelbtn" :okbtn="confirm.okbtn" @ConfirmEvent="confirmEvent" />
    <va-confirm-payment :show="cpform" :data="sales" @DialogEvent="cpEv"/>
    <va-customer-form :show="cusform" :state="customer_state" @DialogEvent="formEv"/>
    <va-product-finder :show="finder"  @DialogEvent="finderEv"/>
     <va-status-dialog :show="statusDialog" :sales="sales" @DialogEvent="statEv"/>
     <zera-image-viewer :show="imgview" :imgsrc="imgsrc" @DialogEvent="imgview = false"/>
  </v-dialog>
</template>

<script>

export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    selectedID: {
       type: Number,
        default: null
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      confirm: {
        message:"",
        cancelbtn: "Close",
        okbtn: "OK",
        action:"",
        show: false
      },
      action:"",
      menu:false,
      cpform: false,
      imgview: false,
      imgsrc:"",
      newcustomer: false,
      activity: false,
      job_remarks:"",
      valid: true,
      statusDialog: false,
      loading: false,
      discount_request:"",
      customer_state: "new",
      cusform: false,
      finder: false,
      customers:[],
      s3upload: false,
      newpassword:'',
      show1: false,
      sales_items:[],
      sales: {customer_data: {mobile:""}},
      tax:0,
      sales_types:[],
      payment_frequencies:[],
       textRules: [
        v => !!v || 'Field is required'
      ],
      USERID: 0,
  }),
  computed: {
      CAN_ENTRY() {
         if(this.sales.status=='Completed' || this.sales.status=='Cancelled' || this.sales.payment_status=='Paid') {
          return false
         } else {
          return true
         }
      },
      SUBTOTAL() {
        var total =this.sales_items.reduce((res,item)=>{
          res = this.$IsNum(res) + (this.$IsNum(item.selling_price)* this.$IsNum(item.quantity))
            return res
        },0)
        return total
      },
       TAXES(){
          var tax = this.$IsNum(this.tax/100)
          if(this.sales.payment_status == "Paid") {
            return this.$IsNum(this.sales.tax)
          }
        return this.$IsNum(this.SUBTOTAL * tax)
      },
       DISCOUNT(){
       
        return this.$IsNum(this.sales.discount)
      },
       TOTAL(){
        if(this.saleprops('Rental,Subscription,Installment')) {
             return this.$IsNum(this.sales.payment_length) * this.$IsNum(this.sales.due_amount)
        } else {
            return this.$IsNum(this.SUBTOTAL + this.TAXES) - this.$IsNum(this.DISCOUNT)
        }
        
      },
     
  },
  watch: {
    show (v) {
      if (v) {
          this.sales_types =  this.GET_SYSVARS('sales_order_types')
          this.payment_frequencies =  this.GET_SYSVARS('payment_frequencies')
          this.tax =  this.$IsNum(this.GET_SYSVARS('tax'))
          this.sales_items = []
          this.action = this.state
          this.getCustomers()
            this.USERID = this.$IsNum(this.$session.get('userID'))
          this.activity=false
           this.s3upload = false
          if(this.state == 'modify') {
            this.s3upload = true
            this.getSales(this.selectedID)
          }
      } else {
        this.sales = {customer_data: {mobile:""}}
      }
    }
  },
  methods: {
    printView(){
      var  route = this.$router.resolve({
       path: "/print-view/"+this.sales.id
      });
    window.open(route.href, "_blank");
    },
    complete(){
      if(this.sales.payment_status != "Paid") {
           this.confirm = {
        message:"Please proceed to payment first.",
        cancelbtn: "Close",
        okbtn: "Ok",
        action:"payment required",
        show: true
      }
      return
      }
     this.confirm = {
        message:"Job Order " + this.sales.id + ' is completed?',
        cancelbtn: "Close",
        okbtn: "Confirm",
        action:"Complete",
        show: true
      }
    },
    cancel(){
     this.confirm = {
        message:"Cancel sales " + this.sales.id + '?',
        cancelbtn: "Close",
        okbtn: "Confirm and cancel",
        action:"Cancel",
        show: true
      }
    },
    _resetConfirm(){
      this.confirm = {
        message:"",
        cancelbtn: "Close",
        okbtn: "OK",
        action:"",
        show: false
      }
    },
    confirmEvent(e){
      if(e=='ok') {
          if(this.confirm.action == 'Cancel') {
            this.sales.status = "Cancelled"
             this.sales.remarks='Sales has been cancelled'
            this.sales.payment_status='Unpaid'
            console.log("to cancel", this.sales)
            this.Update()
             setTimeout(()=>{
              this.PostLog('Sales has been cancelled!')
              this._resetConfirm()
            },500)
          } else if(this.confirm.action == 'Complete') {
            this.sales.status='Completed'
            this.sales.remarks='Job Order Completed'
            this.Update()
             setTimeout(()=>{
              this.PostLog('Job Order is now completed.')
              this._resetConfirm()
            },500)
          } else {
             this._resetConfirm()
          }
      } else {
         this._resetConfirm()
      }
    },
    cpEv(e){
        this.cpform=false
        this.loading=false
        if(e == 'confirmed'){
            this.PostLog("Received and confirm payment.")
            setTimeout(()=>{
              if(this.sales.type== 'Job Order') {
                  this.getSales(this.selectedID)
              } else {
                this.emitToParent()
              }
                 
            },1000)
        } else {
         setTimeout(()=>{
            this.emitToParent()
         },500)
            
        }
    },
    s3Ev(array_images){
      if(this.sales.files == null) {
        this.sales.files = array_images
      } else {
        this.sales.files = this.sales.files.concat(array_images)
      }
      this.validate()
      setTimeout(()=>{ this.PostLog("New images has been uploaded") },1300)
      
      },
    statEv(id){
     this.statusDialog = false
     this.getSales(id)
    },
    validate(){
       if (this.$refs.form.validate()) {
           
        
         
            
             if(this.action=='new') {
               this.sales.payment_status="Unpaid"
              this.Add()
            } else {
              this.Update()
            }
            
        } else {
          this.loading = false
        }
    },
    sumDiscount(discounts){
        var total = discounts.reduce((res,item)=>{
              res = this.$IsNum(res) + this.$IsNum(item.amount)
            return res
        },0)
        
        return total
    },
      discEv(item){
     
         var newitem = {
            name: item[0].value,
             amount: this.$IsNum(item[1].value),
          }
        if(this.IsEmpty(this.sales.discount_items)) {
          this.sales.discount_items = [newitem]
        } else {
            this.sales.discount_items.push(newitem)
        }

        this.sales.discount = this.sumDiscount(this.sales.discount_items)
        console.log("discount:",  this.sumDiscount(this.sales.discount_items))
        if(this.sales.discount >0) {
           this.sales.discount_request = "Approved"
          this.validate()
          setTimeout(()=>{this.PostLog('Adding discount...')},500)
        }
       
      },
    removeItem(index){
      this.sales_items.splice(index,1)
    },
    finderEv(e){
      this.finder = false
      if(e!='close'){
          if(this.sales_items.length>0) {
            console.log("added", e)
            this.sales_items = this.sales_items.concat(e)
          } else {
            this.sales_items = e
          }
      }
    },
    formEv(){
      this.cusform=false
      this.newcustomer = true
       this.getCustomers()
    },
      saleprops(_types){
        if(!this.sales.type){
          return false
        }
        let typesArr = _types.split(',')
        for(var i=0; i<typesArr.length;i++) {
          if(this.sales.type == typesArr[i]){
            return true
          }
        }
      },
       PostLog(message){
         let nlog =  {
                "user": this.$session.get('fullname'),
                "message": this.Strip(message),
                "timestamp": this.$moment().format("YYYY-MM-DD hh:mm A")
            }
             if(this.sales.service_logs == null || this.sales.service_logs == "" || this.sales.service_logs == undefined) {
            this.sales.service_logs = [nlog]
        } else {
            this.sales.service_logs.push(nlog)
        }
    
           let params = {
            table: "sales", 
            type:"update",
            query:`update sales set  service_logs='${JSON.stringify( this.sales.service_logs)}'::jsonb where id=${this.sales.id}`
        }
   
        this.$http.post("new_data", params).then(response => {
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
        this.message = ""
        }).catch(e => {
          console.log(e.data)
        })
    },
       AcceptJob(message){
        var service_logs = []
        var log = {}
      
        log.timestamp =  this.$moment().format("YYYY-MM-DD hh:mm A")
        log.user =  this.$session.get('fullname')
        log.message = message
        
        if(this.sales.service_logs == null || this.sales.service_logs == "" || this.sales.service_logs == undefined) {
            service_logs.push(this.log)
            this.sales.service_logs = service_logs
        } else {
            this.sales.service_logs.push(log)
        }
          var qryStr = `update sales set  service_personnel=${this.USERID}, status='${this.sales.status}',payment_status='${this.sales.payment_status}', remarks='${this.sales.remarks}', service_logs='${JSON.stringify(this.sales.service_logs)}' where id=${this.sales.id}`
          if(this.sales.status == 'For Inspection') {
              qryStr = `update sales set status='${this.sales.status}',payment_status='${this.sales.payment_status}', remarks='${this.sales.remarks}', service_logs='${JSON.stringify(this.sales.service_logs)}' where id=${this.sales.id}`
          }
          let params = {
            table: "product_items", 
            type:"update",
            query:qryStr
        }
   
        this.$http.post("new_data", params).then(response => {
          console.log(response)
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
           // this.emitToParent()
           setTimeout(()=>{ this.getSales(this.sales.id)}, 1000)
        }).catch(e => {
          console.log(e.data)
        })
    },
        Update(){
          console.log("update",  this.sales)
        this.$http.post("update_sales", this.sales).then(response => {
          console.log(response)
          this.loading=false
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 3000)
        
          this.sales = response.data.sale
          setTimeout(()=>{ this.getSales(this.sales.id)}, 1000)
        }).catch(e => {
          console.log(e.data)
        })
      },
      Add(){
        this.$http.post("add_sales", this.sales).then(response => {
          console.log(response)
          this.loading=false
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
        
          this.sales = response.data.sale
          if(this.sales.type=='Job Order') {
              this.statusDialog = true
          } else {
              this.cpform=true
          }
          
        }).catch(e => {
          console.log(e.data)
        })
      },
      setCustomer(){
            var customer = this.customers.find(u => u.id === this.sales.customer_id);
            return customer
      },

      getCustomers(){
            this.QUERY('customers',`select id,  (profile->>'firstname') || ' ' || (profile->>'lastname') AS fullname, contact->>'mobile' as mobile from customers order by id desc`, (res)=>{
              if(res.status) {
                this.customers=res.results
                if(this.newcustomer) {
                  this.sales.customer_id = this.customers[0].id
                  setTimeout(()=>{
                    this.newcustomer = false
                  },1000)
                }
              }
             
            })
        
      },

       getSales(_salesID){
        console.log("getSales")

            this.QUERY('sales',`select * from sales where id=${_salesID}`, (res)=>{
              console.log(res)
              if(res.status) {
                this.sales=res.results[0]
                console.log("update sales",  this.sales)
                this.sales_items = this.sales.product_items
                this.action = "modify"
                this.activity = true
              }
             
            })
        
      },
     
    emitToParent () {
        this.$emit('DialogEvent', "")
    }
  }
}
</script>
